// extracted by mini-css-extract-plugin
module.exports = {"root":"Images90_root__1BDDb","title":"Images90_title__w5kwz","images":"Images90_images__3KqMi"};